export const mapKey = window.mapKey;
export const loadGoogleMaps = (callback) => {
  const existingScript = document.getElementById("googleMaps");

  if (!existingScript) {
    //AIzaSyD1IR-VveW30kbdlxoKBYaE9A_h9t7VFtM
    const script = document.createElement("script");
    script.src = mapKey;
    // "https://maps.google.com/maps/api/js?key=AIzaSyADbLQEk2rxX21_F1anXqACZnN5_vdAxhg&libraries=places";
    ("https://maps.google.com/maps/api/js?key=AIzaSyC2t2b9kM4EQzgg6-pj9eMy_E0hZ4Dr-k4&libraries=places");
    script.id = "googleMaps";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      //initialize();
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};

export const removeGoogleMaps = () => {
  const mapScript = document.getElementById("googleMaps");

  if (mapScript) {
    mapScript.parentNode.removeChild(mapScript);

    const head = document.getElementsByTagName("head")[0];
    const scripts = head.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      let script = scripts[i];
      let src = script.src;

      if (src.startsWith("https://maps.google.com/maps")) {
        head.removeChild(script);
      }
    }
  }
};
